import React from "react";
import { Navigate } from "react-router-dom";

const Pages = () => {
  return <Navigate to={"/auth/login"} />;
};

export default Pages;
